import { render, staticRenderFns } from "./LiefengUploadExcel.vue?vue&type=template&id=24d2da05&scoped=true&"
import script from "./LiefengUploadExcel.vue?vue&type=script&lang=js&"
export * from "./LiefengUploadExcel.vue?vue&type=script&lang=js&"
import style0 from "./LiefengUploadExcel.vue?vue&type=style&index=0&id=24d2da05&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d2da05",
  null
  
)

export default component.exports